import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const CATEGORIES = [
  { name: "STRATEGY", tagline: "Find Direction", testid: "service-category-strategy" },
  { name: "PROGRAMS & PRODUCTS", tagline: "Make the Work Work", testid: "service-category-program-product" },
  { name: "SYSTEMS & CAPACITY", tagline: "Build Capacity", testid: "service-category-systems-capacity" },
  { name: "AI & AUTOMATION", tagline: "Create Leverage", testid: "service-category-ai-automation" },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="scroll-mt-20 py-20 sm:py-28 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          chapter="05 — Services"
          title="How I can help"
          testid="services-head"
        />

        <div className="mt-14 grid grid-cols-1 gap-px border border-line bg-line sm:grid-cols-2">
          {CATEGORIES.map((c, i) => (
            <Reveal key={c.name} delay={i * 0.08} className="h-full">
              <div
                data-testid={c.testid}
                className="group h-full bg-paper p-8 transition-colors duration-300 hover:bg-amber-soft sm:p-10"
              >
                <p className="flex items-baseline gap-3 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-ink">
                  <span className="text-amber">{String(i + 1).padStart(2, "0")}</span>
                  {c.name}
                </p>
                <p className="mt-4 font-serif text-2xl font-light text-ink sm:text-[1.65rem]">
                  {c.tagline}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Ways we work together */}
        <Reveal delay={0.1}>
          <div data-testid="services-ways-we-work" className="mt-6 border border-line bg-parch p-8 sm:p-10">
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-amber">
              Ways We Work Together
            </p>
            <div className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-3">
              {[
                { label: "STRATEGY SPRINTS", desc: "Turn a challenge into a clear strategy, priorities and next steps.", to: "/workshops#strategy-sprint", testid: "ways-sprints" },
                { label: "WORKSHOPS", desc: "Build capability with your team.", to: "/workshops#the-workshops", testid: "ways-workshops" },
                { label: "DEEP CONSULTING", desc: "Build, change or improve something more substantial.", to: "/contact", testid: "ways-consulting" },
              ].map((w) => (
                <Link key={w.label} to={w.to} data-testid={w.testid} className="group block">
                  <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-ink transition-colors group-hover:text-amber">
                    {w.label}
                  </p>
                  <p className="mt-3 font-serif text-xl font-light leading-snug text-body">
                    {w.desc}
                  </p>
                  <span className="mt-4 block h-px w-10 bg-amber/60 transition-all duration-500 group-hover:w-full" />
                </Link>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-12">
            <Link
              data-testid="services-cta-explore"
              to="/services"
              className="group inline-flex items-center gap-2 border-b border-ink/30 pb-1 text-sm font-semibold tracking-wide text-ink transition-colors duration-300 hover:border-amber hover:text-amber"
            >
              Explore Services
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
